import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { TRACK_PAGE, TRACK_EVENT } from 'actions/analytics/tracking';

const INITIAL_STATE = Immutable({
  pageContext: null,
  latestTracked: null,
  dataHasBeenSet: false,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case TRACK_PAGE:
    case TRACK_EVENT: {
      return state.merge({
        latestTracked: action.payload,
        dataHasBeenSet: true,
      });
    }
    default:
      return state;
  }
};
